import React from "react";
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types'
import ClipLoader from "react-spinners/ClipLoader";

const Button = ({ isDisabled, buttonText, onClick, classes, loader }) =>
{
  const { uiTheme } = useSelector((state) => state.activation);
  return (
    <div className="row">
      <div className="col-xs-24 rel" style={{ width: "fit-content" }}>
        <input
          type="button"
          className={`button ext-button primary ext-primary ${classes}`}
          value={buttonText}
          style={{ backgroundColor: uiTheme.buttonColour, color: uiTheme.buttonFontColour, borderColor: uiTheme.buttonColour }}
          disabled={isDisabled || loader}
          onClick={onClick}
        />
        <ClipLoader
          color={"#ffffff"}
          loading={loader}
          size={20}
          aria-label="Loading Spinner"
          data-testid="loader"
          className="button-loader"
        />
      </div>
    </div>
  );
};

Button.propTypes = {
  isDisabled: PropTypes.bool,
  buttonText: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  classes: PropTypes.string,
  loader: PropTypes.bool
};

export default Button;
